<template>
  <div
    class="w-full top-0 duration-300 p-4"
    :class="
      isWidget ? 'pt-2' : 'pt-0 h-full max-w-3xl mx-auto overflow-y-auto no-scrollbar'
    "
  >
    <div v-if="!isWidget" class="h-16 w-full top-0 bg-inherit z-10"></div>
    <div class="flex gap-4 justify-between items-center mb-4">
      <p class="opacity-70 relative flex items-center gap-1 text-lg font-bold">
        Recent <SpinIcon v-if="isRefetching" />
      </p>
      <AppButton
        v-if="!isWidget"
        icon="pi pi-plus"
        :label="$t('new')"
        @click="emit('startNew')"
      />
    </div>
    <template v-if="isLoading">
      <RecentConversationListItemLoading v-for="i in 5" :key="i" />
    </template>
    <ConversationListEmpty
      v-else-if="!data?.length"
      class="h-[calc(100%-6rem)]"
      @create="emit('create')"
    />
    <AppError v-else-if="isError" class="scale-75 mt-8" />

    <template v-else>
      <RecentConversationListItem
        v-for="item in data"
        :key="item.id"
        :item="item"
        :active="activeId === item.id"
        @set-active-id="setActiveId"
      />
      <div ref="lastItem" class="lastItem"></div>
      <div v-if="isFetchingNextPage" class="flex items-center justify-center">
        <SpinIcon />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import AppError from "@/components/shared/AppError.vue";
import RecentConversationListItem from "./RecentConversationListItem.vue";
import RecentConversationListItemLoading from "./meta/RecentConversationListItemLoading.vue";
import ConversationListEmpty from "./meta/ConversationListEmpty.vue";
import SpinIcon from "@/components/icons/SpinIcon.vue";

defineProps<{
  isWidget?: boolean;
}>();

const emit = defineEmits(["close", "create", "startNew"]);
const {
  data,
  isLoading,
  isError,
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
  isRefetching,
} = useRecentV2ConversationList();
const v2ResponseStore = useV2ResponseStore();
const lastItem = ref<HTMLElement | null>(null);

const activeId = computed(() => v2ResponseStore.lastConversationId);

useIntersectionObserver(lastItem, ([{ isIntersecting }]) => {
  if (isIntersecting && hasNextPage.value && !isFetchingNextPage.value) {
    fetchNextPage();
  }
});

function setActiveId(id: string) {
  v2ResponseStore.lastConversationId = id;
  v2ResponseStore.isNewConversation = false;
  nextTick(() => {
    v2ResponseStore.messages = [];
    emit("close");
  });
}
</script>
